import React, { ChangeEvent } from 'react';
import { MenuItem, Select } from '@material-ui/core';
import CustomInput from '../../../../../common/input/CustomInput';
import { AssignmentQuestionFormat } from '../../../state/assignment-edit.types';
import { useAppSelector } from '../../../../../../../redux/hooks';

interface AssignmentQuestionFormatSelectProps {
  format: number;
  id: string;
  handleAssignmentEdit(
    id: string,
    format: AssignmentQuestionFormat,
    rootId?: string
  ): any;
  rootId?: string;
  questionTypes: any[];
}

const AssignmentQuestionFormatSelect: React.FC<AssignmentQuestionFormatSelectProps> = (
  props: AssignmentQuestionFormatSelectProps
) => {
  const { format, id, handleAssignmentEdit, rootId, questionTypes } = props;

  const handleQuestionFormat = (evt: ChangeEvent<any>) => {
    const questionFormat = evt.target.value;
    handleAssignmentEdit(id, questionFormat, rootId);
  };
  return (
    <Select
      value={format}
      onChange={handleQuestionFormat}
      input={<CustomInput />}
    >
      {questionTypes.map((questionFormat: any, index: number) => (
        <MenuItem key={index} value={questionFormat.id}>
          {questionFormat.name}
        </MenuItem>
      ))}
    </Select>
  );
};

export default AssignmentQuestionFormatSelect;
